import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { QnaEmpty } from '../../icons';

@Component({
  tag: 'ugc-qna-no-data',
  shadow: false,
})
export class UgcQnaNoData {
  render() {
    const {
      isFirstLoad,
      isQnaLoaded,
      qids,
      qnaStaticLanguage: { IDS_UGC_QNA_LIST_EMPTY_NOTICE = '' },
      isDesktop,
    } = state;
    const isHasNoQna = isFirstLoad && isQnaLoaded && qids.length === 0;
    return (
      isHasNoQna && (
        <div class="flex-col-center-center p-32">
          <QnaEmpty width={isDesktop ? '110' : '88'} height={isDesktop ? '90' : '72'} />
          <div class="mt-36 mb-16">
            <ugc-title
              class="list-data-empty"
              size={18}
              height={36}
              style={{
                display: 'block',
                padding: '0 20px',
                textAlign: 'center',
              }}
              text={IDS_UGC_QNA_LIST_EMPTY_NOTICE}
            />
          </div>

          <div style={{ width: '300px' }}>
            <ugc-qna-ask-question />
          </div>
        </div>
      )
    );
  }
}
